import { v4 as uuid } from "uuid"
import { Serializable } from "@/core/api/decorators/serializable_decorator"
import {
  ArrayMinSize,
  IsArray,
  IsDefined,
  IsNotEmpty,
  ValidateIf,
  ValidateNested,
} from "class-validator"
import { PriceCategoryBaseModel } from "./categories/priceCategoryBaseModel"

@Serializable
export class SubAreaModel {
  uid: string = uuid()
  @ValidateIf(() => false, { groups: ["free_pricing"] })
  @IsNotEmpty({
    message: "common:fill_candidate_before_sharing",
    groups: ["supplier", "internal", "rfs"],
  })
  @IsNotEmpty({
    message: "common:must_be_filled",
    groups: ["internal_kanban", "subareas", "rfs"],
  })
  @IsDefined({
    message: "create_agreement:subareas.subarea_error",
    groups: ["supplier"],
  })
  name: string = ""
  headline: string = ""
  @IsNotEmpty({
    message: "create_agreement:subareas.subarea_error",
    groups: ["subareas", "rfs"],
  })
  @IsDefined({
    message: "create_agreement:subareas.subarea_error",
    groups: ["subareas"],
  })
  headlineNumber: number = 1
  @ValidateIf(() => false, { groups: ["free_pricing"] })
  @ValidateIf((o: SubAreaModel) => o?.name !== "", {
    groups: ["supplier_draft"],
  })
  @ArrayMinSize(1, {
    message: "common:must_be_filled",
    groups: ["internal_kanban", "supplier_draft", "rfs"],
  })
  @ArrayMinSize(1, {
    message: "common:fill_candidate_before_sharing",
    groups: ["supplier", "internal"],
  })
  @IsArray({
    message: "create_proposal:prices.choose_consultant_category_error",
    groups: ["price_with_category"],
  })
  @ArrayMinSize(1, {
    message: "create_proposal:prices.choose_consultant_category_error",
    groups: ["price_with_category", "prices"],
  })
  @ValidateNested({
    each: true,
    groups: ["internal", "supplier", "supplier_draft", "price_table", "rfs"],
  })
  categories: PriceCategoryBaseModel[] = []

  constructor(data?: Partial<SubAreaModel> | null) {
    if (data) {
      Object.assign(this, data)
    }
  }
}
